import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { AppFeedback } from '../app-feedpack.js';

export const submitAppFeedbackMutation = registerMutation({
  operationName: 'submitAppFeedbackMutation',
  type: () => Boolean,
  params: [
    { name: 'type', type: () => String },
    { name: 'message', type: () => String },
    { name: 'imageFileIds', type: () => [String] },
  ],
  resolve: (type: string, message: string, imageFileIds: string[]) => async () => {
    const currentUser = await CurrentUserInfo.getMyself()({ _id: 1 });
    if (!currentUser?._id) {
      throw new Error('Not authenticated');
    }

    const feedbackDoc = new AppFeedback({
      userId: currentUser._id,
      type,
      message,
      imageFileIds: imageFileIds.length ? imageFileIds : null,
      timestamp: new Date().toISOString(),
      status: 'open',
    });

    await (await getCollection(AppFeedback)).insertOne(feedbackDoc.toObject());

    return true;
  },
});
